import xlsx from 'xlsx'

export function parseXlsx (data) {
  let workbook = xlsx.read(data, {type: 'binary'})
  let items = []
  workbook.SheetNames.forEach(sheetName => {
    const roa = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName])
    items.push(roa)
  })
  items = items[0]

  let result = parseXlsxRule01(items)

  return result
}

function parseXlsxRule01 (items) {
  const xlsxData = []
  let xlsxColumn = {}
  const titleIndex = items[0]['__EMPTY_1'] ? 0 : 1
  for (let [key, name] of Object.entries(items[titleIndex])) {
    const col = String(name).trim()
    if (col) {
      xlsxColumn[key] = col
    }
  }

  for (let i = titleIndex + 1; i < items.length; i++) {
    let item = {}
    for (let [key, value] of Object.entries(items[i])) {
      const col = xlsxColumn[key]
      if (col) {
        item[col] = value
      }
    }
    xlsxData.push(item)
  }

  return {
    column: xlsxColumn,
    data: xlsxData
  }
}



// WEBPACK FOOTER //
// ./src/lib/parse-file.js